import React, { useState } from "react";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { SnackbarData, SnackbarType } from "../Snackbar";
import { shippingReportsApi } from "../../services/shippingReportsApi";
import { generateUniqueNumber, isSunDistribution } from "../../shared/utility";

type Props = {
  parentType: "shipping" | "sunOrder";
  parentId: number | string;
  logout: () => void;
  addSnackbar: (snackbar: SnackbarData) => void;
};

export default function ShipmentReportButton({
  parentType,
  parentId,
  logout,
  addSnackbar,
}: Props) {
  const navigate = useNavigate();
  const [opening, setOpening] = useState(false);

  if (!isSunDistribution()) {
    return null;
  }

  const openReport = async () => {
    setOpening(true);
    const result =
      parentType === "shipping"
        ? await shippingReportsApi.createForShipping(parentId)
        : await shippingReportsApi.createForSunOrder(parentId);
    setOpening(false);

    if (result.success) {
      navigate(`/shipping-reports/${result.data.id}`);
      return;
    }

    if (result.errorStatus === 401) logout();
    addSnackbar(
      new SnackbarData(
        generateUniqueNumber().toString(),
        result.data?.message ?? "Could not open the shipment report",
        SnackbarType.Error,
      ),
    );
  };

  return (
    <button
      type="button"
      disabled={opening}
      onClick={openReport}
      className="inline-flex items-center justify-center gap-2 rounded-md bg-main-purple px-3.5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60"
    >
      <ClipboardDocumentListIcon className="h-5 w-5" />
      {opening ? "Opening Report..." : "Shipment Report"}
    </button>
  );
}
